import gql from 'graphql-tag';
export const CREATE_HIGHLIGHT = gql`
  mutation CreateHighlight($input: HighlightInput!) {
    createHighlight(input: $input) {
      _id
    }
  }
`;

export const UPDATE_HIGHLIGHT = gql`
  mutation UpdateHighlight($id: MOID!, $input: HighLightUpdate!) {
    updateHighlight(id: $id, input: $input)
  }
`;

